import React from "react";
import Blogs from "../../components/Blogs";
import InnerBanner from "../../components/InnerBanner";

const BlogsPage = () => {
  return (
    <>
      <InnerBanner title="Blogs"/>
      <Blogs/>
    </>
  );
};

export default BlogsPage;
